import React from 'react'

import { usePrices } from 'src/hooks/usePrices'
import { PriceType } from 'src/types/prices'

import OfferPriceNet from './OfferPriceNet'
import OfferPriceNetTotal from './OfferPriceNetTotal'
import OfferPriceGross from './OfferPriceGross'
import OfferPriceAllIn from './OfferPriceAllIn'
import type { PriceDataType } from 'client/components/PriceDetailsFactory'
import OfferPriceAllInDaily from './OfferPriceAllInDaily'
import OfferPriceNetWithFees from './OfferPriceNetWithFees'
import OfferPriceNetWithFeesDaily from './OfferPriceNetWithFeesDaily'

export interface IBoardPrice {
  currency: string
  discount: number
  finalPrice: number
  initialPrice: number
  pricePerNight: number
  pricePerNightSubtotal: number
  pricePerNightWithFees: number
  subtotal?: number
  totalWithFees: number
  subtotalWithFees?: number
  subtotalNightlyWithFees?: number
  taxDetails?: Array<{
    amount: number
    currency: string
    client: {
      amount: number
      currency: string
    }
    included: boolean
    name: string
  }>
  additionalFees?: Array<{
    amount: number
    currency: string
    local?: {
      amount: number
      currency: string
    }
  }>
  insuranceSelected?: boolean
}

export interface OfferPriceProps {
  className?: string
  board: IBoardPrice
  nights?: number
  priceData?: PriceDataType
  prime?: boolean
  showFrom?: boolean
  showDiscount?: boolean
  showDiscountBadge?: boolean
  showSubtitle?: boolean
  loading?: boolean
}

const pricesOptions = {
  [PriceType.Net]: OfferPriceNet,
  [PriceType.Gross]: OfferPriceGross,
  [PriceType.AllIn]: OfferPriceAllIn,
  [PriceType.AllInDaily]: OfferPriceAllInDaily,
  [PriceType.TrivagoNet]: OfferPriceNetTotal,
  [PriceType.NetWithFees]: OfferPriceNetWithFees,
  [PriceType.NetWithFeesDaily]: OfferPriceNetWithFeesDaily,
}

const OfferPrice = ({
  className,
  board,
  nights,
  priceData,
  prime,
  showFrom = false,
  showDiscount = true,
  showDiscountBadge = true,
  showSubtitle = true,
  loading = false,
}: OfferPriceProps) => {
  const { priceType } = usePrices({ rooms: [] })

  const PriceComponent = pricesOptions[priceType]

  return (
    <PriceComponent
      className={className}
      board={board}
      nights={nights}
      priceData={priceData}
      prime={prime}
      showDiscount={showDiscount}
      showDiscountBadge={showDiscountBadge}
      showFrom={showFrom}
      showSubtitle={showSubtitle}
      loading={loading}
    />
  )
}

export default OfferPrice
